import { FormikErrors } from "formik";

 export const handleFormikErrors = (errors: FormikErrors<unknown>,callback:(e:string)=>void) => {
  // Recursive function to handle nested errors
  const extractErrors = (errors: FormikErrors<unknown>, prefix: string = '') => {
    Object.keys(errors).forEach((key) => {
      const value = (errors as Record<string, unknown>)[key];

      // If the value is an object or array, recurse deeper
      if (typeof value === 'object' && value !== null) {
        extractErrors(value, `${prefix}${key}.`); // Append the key for nested structure
      } else {
        // If it's a string (error message), show the toast
         callback(value as string)
      }
    });
  };

  // Start the recursive extraction from the root errors object
  extractErrors(errors);
};
